<template>
  <div class="trade-page">
    <div class="headerWrapper">
      交易
      <i class="icon iconfont install" @click="goSet">&#xe66e;</i>
    </div>

    <div class="wrapper">
      <div class="user-row">
        <div class="user-col">
          <span class="user-label">用户名：</span>
          <span class="user-value">{{ userName || "-" }}</span>
        </div>
        <div class="user-col user-col-right">
          <span class="user-label">账号：</span>
          <span class="user-value">{{ pageData.account.value || "-" }}</span>
        </div>
      </div>

      <div class="asset-card">
        <div class="asset-top">
          <span class="asset-title">{{ pageData.rights.title }}：</span>
          <span class="asset-value">{{ pageData.rights.value }}</span>
        </div>
        <div class="asset-list">
          <div class="asset-row">
            <span class="asset-label">{{ pageData.usable.title }}：</span>
            <span class="asset-number">{{ pageData.usable.value }}</span>
          </div>
          <div class="asset-row">
            <span class="asset-label">{{ pageData.profitAloss.title }}：</span>
            <span :class="profitClass" class="asset-number">{{ pageData.profitAloss.value }}</span>
          </div>
          <div class="asset-row">
            <span class="asset-label">{{ pageData.margin.title }}：</span>
            <span class="asset-number">{{ pageData.margin.value }}</span>
          </div>
        </div>
      </div>

      <div class="menu">
        <ul>
          <li
            v-for="(item, index) in menuData"
            :key="index"
            :class="{ liActive: isActive == index }"
            v-tap
            @tap="link(index)"
          >
            <i class="icon iconfont menu-icon" v-html="item.tobarIcon"></i>
            <span class="menu-label">{{ item.tobarContent }}</span>
          </li>
        </ul>
      </div>

      <div class="btn_div_d" v-tap @tap="go_login">
        <div class="btn">退出登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import yjheader from "@/components/common/yjheader";
import art from "../../../static/js/proto/art/Art.js";
import model from "../../../static/js/proto/Model.js";
import front from "../../../static/js/proto/CtpFront.js";
import * as SubUtils from "@/store/SubUtils";
export default {
  name: "trade",
  components: {
    yjheader
  },
  data() {
    return {
      userName: '',
      pageData: {
        account: { title: "账号", value: localStorage.accountNum },
        rights: {
          title: "权益",
          value: "0.00"
        },
        usable: {
          title: "可用",
          value: "0.00"
        },
        profitAloss: {
          title: "盈亏",
          value: "-0.00"
        },
        margin: {
          title: "保证金",
          value: "0.00"
        }
      },
      menuData: [
        {
          tobarLink: "/home/order",
          tobarIcon: "&#xe624;",
          tobarContent: "下单"
        },
        {
          tobarLink: "/home/store",
          tobarIcon: "&#xe7b9;",
          tobarContent: "持仓"
        },
        {
          tobarLink: "/home/cancel",
          tobarIcon: "&#xe609;",
          tobarContent: "撤单"
        },
        {
          tobarLink: "/home/capital",
          tobarIcon: "&#xe60a;",
          tobarContent: "资金"
        },
        {
          tobarLink: "/home/query",
          tobarIcon: "&#xe603;",
          tobarContent: "查询"
        }
      ],
      isActive: 12
    };
  },
  computed: {
    profitNumber() {
      return Number(this.pageData.profitAloss.value);
    },
    profitClass() {
      return this.profitNumber < 0 ? "profit-negative" : "profit-positive";
    }
  },
  mounted() {},
  beforeDestroy() {},

  activated() {
    this.userName = localStorage.userName;
    front.autoMount(art.bind(this, this.load));
    this.$store.commit("selectIndex", 2);
  },
  deactivated() {
    model.trader.queryCapital.stop();
  },

  methods: {
    load(onFail) {
      model.capital.attach("trade", art.bind(this, this.onUpdateCapital));
      model.trader.queryCapital.start();
      // 自动重连后切回交易页面
      if (onFail instanceof Function) {
        this.$router.push({ path: "/home/trade" });
      }
    },
    onUpdateCapital(capital) {
      if (capital === undefined) {
        this.pageData.rights.value = 0.0;
        this.pageData.usable.value =  0.0;
        this.pageData.profitAloss.value = 0.0;
        this.pageData.margin.value = 0.0;
        this.pageData.account.value = 0.0;
        return;
      }
      this.pageData.rights.value = capital["balance"].toFixed(2);
      this.pageData.usable.value = capital["available"].toFixed(2);
      this.pageData.profitAloss.value = (Number(capital["positionProfit"]) + Number(capital["closeProfit"])).toFixed(2);
      this.pageData.margin.value = capital["currMargin"].toFixed(2);
      this.pageData.account.value = capital["account"];
    },
    go_login() {
      front.close();
      SubUtils.clearAll();
      footerIndex = 0;
      this.$router.push({ path: "/" });
      this.$store.commit("selectLoad"); // 清空自选合约
    },
    link(index) {
      this.isActive = index;
      this.$router.push({ path: "/tradeDetail/" + index });
    },
    goSet() {
      this.$router.push('/setPage');
    }
  },
};
</script>

<style scoped>
.iconfont {
  font-family: "iconfont" !important;
  font-size: 0.36rem;
  font-style: normal;
  /*font-weight: bold;*/
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  color: #d4af37;
}

.trade-page {
  min-height: 100vh;
  background: #000;
  color: #fff;
}

.wrapper {
  padding: 0.28rem 0.28rem 0.4rem;
  box-sizing: border-box;
}

.headerWrapper {
  background: #1c201f;
  color: #fff;
  font-size: 0.36rem;
  vertical-align: center;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  position: relative;
  border-bottom: 1px solid rgba(212, 175, 55, 0.18);
}
.headerWrapper .install {
  position: absolute;
  top: 0;
  right: 0.3rem;
  color: #d4af37;
}

.user-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem 0.06rem;
  font-size: 0.28rem;
  color: rgba(255, 255, 255, 0.9);
}

.user-col {
  min-width: 0;
  display: flex;
  align-items: center;
}

.user-col-right {
  justify-content: flex-end;
  text-align: right;
  margin-left: 0.2rem;
}

.user-label {
  color: rgba(255, 255, 255, 0.72);
}

.user-value {
  color: #d4af37;
  max-width: 3.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.asset-card {
  margin-top: 0.18rem;
  padding: 0.28rem 0.28rem;
  border-radius: 0.22rem;
  border: 1px solid rgba(212, 175, 55, 0.42);
  background: rgba(255, 255, 255, 0.04);
  box-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
}

.asset-top {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  gap: 0.16rem;
  min-width: 0;
  margin-bottom: 0.18rem;
}

.asset-title {
  font-size: 0.38rem;
  color: rgba(212, 175, 55, 0.95);
  font-weight: 600;
  white-space: nowrap;
}

.asset-value {
  font-size: 0.44rem;
  line-height: 1.1;
  color: #d4af37;
  font-weight: 800;
  letter-spacing: 0.01rem;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.asset-list {
  display: flex;
  flex-direction: column;
  gap: 0.22rem;
}

.asset-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.16rem;
  font-size: 0.3rem;
  padding: 0.08rem 0;
}

.asset-label {
  color: rgba(255, 255, 255, 0.72);
  white-space: nowrap;
}

.asset-number {
  color: rgba(255, 255, 255, 0.92);
  text-align: right;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profit-positive {
  color: #d4af37;
}

.profit-negative {
  color: rgba(255, 95, 95, 0.92);
}

.menu {
  margin-top: 0.26rem;
  padding: 0.18rem 0.08rem;
  border-radius: 0.22rem;
  border: 1px solid rgba(212, 175, 55, 0.22);
  background: rgba(255, 255, 255, 0.03);
}

.menu ul {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.06rem;
}

.menu ul li {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.16rem 0;
  border-radius: 0.18rem;
}

.menu-icon {
  font-size: 0.42rem;
  color: #d4af37;
  line-height: 1;
}

.menu-label {
  font-size: 0.28rem;
  color: rgba(212, 175, 55, 0.9);
  margin-top: 0.08rem;
  white-space: nowrap;
}

.btn_div_d {
  width: 100%;
  margin: 0.36rem 0 0.1rem;
}

.btn_div_d .btn {
  text-align: center;
  line-height: 0.88rem;
  width: 100%;
  height: 0.88rem;
  margin: 0 auto;
  border: 1px solid rgba(212, 175, 55, 0.42);
  border-radius: 0.22rem;
  display: block;
  font-size: 0.32rem;
  background: transparent;
  color: rgba(255, 255, 255, 0.92);
  letter-spacing: 0.02rem;
}

.liActive {
  background: rgba(212, 175, 55, 0.12);
}
</style>



// WEBPACK FOOTER //
// src/components/yj/trade.vue